(() => {
  const LIBRARY_URL = '/pages/summer-2026-campaign-library';

  const addCampaignNavigation = () => {
    document.querySelectorAll('.delfi-collage').forEach((section, index) => {
      const inner = section.querySelector('.delfi-collage__inner');

      if (!inner || inner.querySelector('.delfi-campaign-nav')) {
        return;
      }

      if (!section.id) {
        section.id = `delfi-campaign-top-${index + 1}`;
      }

      const nav = document.createElement('nav');
      nav.className = 'delfi-campaign-nav';
      nav.setAttribute('aria-label', 'Campaign page navigation');

      const libraryLink = document.createElement('a');
      libraryLink.className = 'delfi-campaign-nav__link';
      libraryLink.href = LIBRARY_URL;
      libraryLink.innerHTML = '<span aria-hidden="true">←</span><span>Campaign Library</span>';

      const topLink = document.createElement('a');
      topLink.className = 'delfi-campaign-nav__link';
      topLink.href = `#${section.id}`;
      topLink.innerHTML = '<span>Back to top</span><span aria-hidden="true">↑</span>';
      topLink.addEventListener('click', (event) => {
        event.preventDefault();

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        section.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });

      nav.append(libraryLink, topLink);
      inner.append(nav);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addCampaignNavigation, { once: true });
  } else {
    addCampaignNavigation();
  }

  document.addEventListener('shopify:section:load', addCampaignNavigation);
})();
